import { GlobalAxios } from "../axios/axios-config";

const ACCESS_CONTROL_VISITOR_SEND_RESTART_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/AccessControlVisitorSend/RestartAccessControlVisitorSend";

export const restartAccessControlVisitorSend = ({
  identifier,
}: {
  identifier: number;
}) => {
  return GlobalAxios.put(ACCESS_CONTROL_VISITOR_SEND_RESTART_ROUTE, {
    identifier,
  });
};

export const restartAccessControlVisitorSendRetries =
  restartAccessControlVisitorSend;
